import $ from 'jquery';

export default function tellja() {

    const paramName = "telljaID";

    function getQueryParam(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    function setCookieTellja(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/; SameSite=Lax`;
    }

    function getCookieTellja(name) {
        const cookies = document.cookie.split('; ');
        for (let i = 0; i < cookies.length; i++) {
            const [cookieName, cookieValue] = cookies[i].split('=');
            if (cookieName === name) return cookieValue;
        }
        return null;
    }

    let rawTelljaId = getQueryParam("telljaid");

    if (rawTelljaId) {
        setCookieTellja(paramName, rawTelljaId, 30);

        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete("telljaid");
        currentUrl.searchParams.set("telljaID", rawTelljaId);
        window.history.replaceState({}, "", currentUrl.href);
    }

    let telljaid = getQueryParam(paramName);
    if (!telljaid) {
        telljaid = getCookieTellja(paramName);
    }

    if (telljaid) {
        document.querySelectorAll("a[href]").forEach(link => {
            let url = new URL(link.href, window.location.origin);
            url.searchParams.set(paramName, telljaid);
            link.href = url.href;
        });

        const currentUrl = new URL(window.location.href);
        if (!currentUrl.searchParams.has(paramName)) {
            currentUrl.searchParams.set(paramName, telljaid);
            window.history.replaceState({}, "", currentUrl.href);
        }
    }

    $(".tariff-button").on("click", function(event) {
        let telljaid = new URLSearchParams(window.location.search).get("telljaID");

        if (!telljaid) {
            let cookies = document.cookie.split("; ");
            for (let i = 0; i < cookies.length; i++) {
                let parts = cookies[i].split("=");
                if (parts[0] === "telljaID") {
                    telljaid = parts[1];
                    break;
                }
            }
        }

        if (telljaid) {
            function addTelljaidToUrl(url, telljaid) {
                if (url) {
                    let parsedUrl = new URL(url, window.location.origin);
                    parsedUrl.searchParams.set("telljaID", telljaid);
                    return parsedUrl.href;
                }
                return url;
            }

            let NewCustomerTariffUrl = addTelljaidToUrl($('#new-customer-tariff-url').attr("href"), telljaid);
            let CustomerLoginUrl = addTelljaidToUrl($('#customer-login-url').attr("href"), telljaid);
            let CustomerWithoutLogin = addTelljaidToUrl($('#customer-without-login').attr("href"), telljaid);

            $('#new-customer-tariff-url').attr("href", NewCustomerTariffUrl);
            $('#customer-login-url').attr("href", CustomerLoginUrl);
            $('#customer-without-login').attr("href", CustomerWithoutLogin);
        }
    });
}
